// FranchiseModal.jsx

import React, { useEffect } from "react";
import { FaPen } from "react-icons/fa";

const FranchiseModal = ({
    showModal,
    setShowModal,
    formData,
    setFormData,
    handleSubmit,
    loading,
    isEdit,
}) => {
    const handleClose = () => {
        setShowModal(false);
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    // ESC close
    useEffect(() => {
        const esc = (e) => e.key === "Escape" && handleClose();
        document.addEventListener("keydown", esc);

        return () => {
            document.removeEventListener("keydown", esc);
        };
    }, []);

    if (!showModal) return null;

    return (
        <div className="oms-overlay">
            <div className="oms-modal" style={{ maxWidth: "900px" }}>

                {/* HEADER */}
                <div className="oms-modal-head">
                    <span className="oms-modal-title">
                        <FaPen size={16} className="me-2" />
                        {isEdit ? "Edit Franchise" : "Add Franchise"}
                    </span>

                    <button
                        className="oms-icon-btn"
                        onClick={handleClose}
                    >
                        ✕
                    </button>
                </div>

                {/* BODY */}
                <div className="oms-modal-body">
                    <div className="oms-form-grid">

                        <div className="oms-form-group">
                            <label className="oms-form-label">First Name</label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter first name"
                                value={formData.firstName || ""}
                                onChange={(e) =>
                                    handleChange("firstName", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Last Name</label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter last name"
                                value={formData.lastName || ""}
                                onChange={(e) =>
                                    handleChange("lastName", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Company Name</label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter company name"
                                value={formData.companyName || ""}
                                onChange={(e) =>
                                    handleChange("companyName", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">
                                User Name{" "}
                                <small className="text-danger">(Spaces are not allowed)</small>
                            </label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter username (no spaces)"
                                value={formData.companyOwner || ""}
                                onChange={(e) =>
                                    handleChange(
                                        "companyOwner",
                                        e.target.value.replace(/\s/g, "")
                                    )
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Order Prefix</label>
                            <input
                                className="oms-form-input"
                                placeholder="e.g. ORD, FC, ABC"
                                value={formData.orderPrefix || ""}
                                onChange={(e) =>
                                    handleChange("orderPrefix", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Password</label>
                            <input
                                type="password"
                                className="oms-form-input"
                                placeholder={isEdit ? "Leave blank to keep old password" : "Enter password"}
                                value={formData.password || ""}
                                onChange={(e) =>
                                    handleChange("password", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">
                                Shipping Office / Address
                            </label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter shipping address"
                                value={formData.shippingoffice || ""}
                                onChange={(e) =>
                                    handleChange("shippingoffice", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">PO Box</label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter PO Box"
                                value={formData.pobox || ""}
                                onChange={(e) =>
                                    handleChange("pobox", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">CNIC</label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter CNIC number"
                                value={formData.cnic || ""}
                                onChange={(e) =>
                                    handleChange("cnic", e.target.value)
                                }
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Contact</label>
                            <input
                                className="oms-form-input"
                                placeholder="Enter contact number"
                                value={formData.contact || ""}
                                onChange={(e) =>
                                    handleChange("contact", e.target.value)
                                }
                            />
                        </div>

                    </div>
                </div>
                {/* FOOTER */}
                <div className="oms-modal-foot">
                    <button
                        className="oms-btn oms-btn-ghost"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="oms-btn oms-btn-primary"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading
                            ? "Saving..."
                            : isEdit
                                ? "Update Franchise"
                                : "Add Franchise"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default FranchiseModal;